export default {
  personalProfile: "Ficha personal",
  myAccount: "Mi cuenta",
  back_to_my_account: "Volver a mi cuenta",
  already_active: "Tu cuenta ya está activada. Inicia sesión.",
};
